"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabelaCorpoCelula = void 0;
var react_1 = __importDefault(require("react"));
var TabelaCorpoCelula = function (_a) {
    var children = _a.children, style = _a.style;
    return (react_1.default.createElement("td", { style: style },
        react_1.default.createElement("div", null, children)));
};
exports.TabelaCorpoCelula = TabelaCorpoCelula;
